import React from 'react'

export const TipoIgicFormView = () => {
  return (
    <div>TipoIgicFormView</div>
  )
}
